import useMediaQuery from '@mui/material/useMediaQuery'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Popover from '@mui/material/Popover'
import * as React from 'react'

interface Props {
  anchorEl: Element | null
  onClose: () => void
  onClosedLostClick: () => void
  onClosedWonClick: () => void
  opportunityId: number
  open: boolean
}

export const ClosedWonLostMenu: React.FC<Props> = (props: Props) => {
  const { anchorEl, open, onClose, onClosedLostClick, onClosedWonClick } = props

  const isMobile = useMediaQuery('(max-width: 600px)')

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      elevation={2}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <List
        sx={{
          width: anchorEl?.clientWidth
            ? isMobile
              ? anchorEl.clientWidth
              : anchorEl.clientWidth - 40
            : '200px',
        }}
        component="nav"
        aria-label="secondary mailbox folders"
        dense
      >
        <ListItem button data-test-id="closedWonListItem">
          <ListItemText primary="Closed Won" onClick={onClosedWonClick} />
        </ListItem>
        <ListItem button data-test-id="closedLostListItem">
          <ListItemText primary="Closed Lost..." onClick={onClosedLostClick} />
        </ListItem>
      </List>
    </Popover>
  )
}

ClosedWonLostMenu.displayName = 'ClosedWonLostMenu'
